import { render } from "./HeroiconsSolidArrowRight.vue?vue&type=template&id=1e952ad3"
const script = {}

import exportComponent from "/Users/nazikban/projects/credit-west-second/packages/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowRight.vue"]])

export default __exports__